import { Http400Code, Http409Code } from '@/api/model/HttpErrorCodes.model.ts';

const unexpectedError = 'Wystąpił nieoczekiwany błąd. Prosimy spróbować ponownie.';

export type UtilsTranslations = {
  errors: {
    unexpectedError: string;
  };
  network: Record<keyof typeof Http400Code, string> &
    Record<keyof typeof Http409Code, string> & {
      401: string;
      '403_ip': string;
      409: string;
      500: string;
      loginError: string;
    };
};

export const utilsTranslations: UtilsTranslations = {
  errors: {
    unexpectedError,
  },
  network: {
    '400_1': unexpectedError,
    '400_6': 'Udzielono już odpowiedź na to pytanie',
    '409_1':
      'Twój quiz jest już zakończony - jeśli jeszcze nie otrzymałeś informacji zwrotnej, wkrótce wyślemy ją do Ciebie mailem!',
    '409_2': 'Czas na ukończenie quizu się skończył',
    '409_3': 'Przekroczono dozwoloną liczbę powrotów do quizu',
    '409_closed': 'Zakończyliśmy zbieranie aplikacji',
    '403_ip':
      'Panel administratora działa tylko z sieci firmowej. Twój adres IP ({{ip}}) nie jest na liście dozwolonych: połącz się przez VPN albo poproś o dodanie adresu.',
    '401': 'Twoja sesja wygasła. Proszę zalogować się ponownie.',
    '409': unexpectedError,
    '500': unexpectedError,
    loginError: 'Nie mogę Cię zalogować - token jest nieprawidłowy lub stracił ważność',
  },
};
